"use client";
import { styles } from "./styles";
import LogoutButton from "../LogOutButton";
import { useAuth } from "@lib/auth/useAuth";
import { Box } from "@ecco/ui/box";
import { CommonCMS } from "@lib/constants/contentful";
import { Flex } from "@ecco/ui/flex";
import { Text } from "@ecco/ui/text";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { Button } from "@ecco/ui/button";
import { useStore } from "@store/index";
import { getPrivacyAttributes } from "@lib/monitoring/privacyAttributes";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { ModalTypes } from "@lib/enums/ModalTypes";

import type { JSX } from "react";
import { RUM_ACTION_NAME } from "@lib/monitoring/rumActionNames";

function AuthenticationActionBar(): JSX.Element {
    const { isLoggedIn, session } = useAuth();
    const { get: getMicrocopy } = useMicrocopy();
    const customer = useStore((state) => state.data.me.customer);
    const { showModal } = useGlobalModalContext();

    const handleCreateAccountClick = () => {
        showModal(ModalTypes.createAccount);
    };

    const handleLoginClick = () => {
        showModal(ModalTypes.login);
    };

    if (isLoggedIn && session) {
        const customerName = [customer?.firstName, customer?.lastName].filter(Boolean).join(" ");
        const loggedInAs = getMicrocopy(CommonCMS.shared, CommonCMS.loggedInAs, {
            replacements: {
                name: session?.user?.name || customerName,
            },
        })?.split(":");

        return (
            <Box w="full" data-testid={"authentication"}>
                <Flex color="gray.800" mb="0.5em">
                    <Text>{loggedInAs?.[0]}</Text>
                    <Text {...getPrivacyAttributes()} color="black" pl={1}>
                        {loggedInAs?.[1]}
                    </Text>
                </Flex>
                <LogoutButton variant="standard" sx={styles.buttons} />
            </Box>
        );
    }

    return (
        <Flex
            w="full"
            data-testid={"authentication"}
            flexDirection={["row"]}
            gap={[0, 0]}
            pl={[3, 0]}
            alignItems="center"
        >
            <Button
                rightIcon={<ECCOIcon name="arrow-right" />}
                onClick={handleCreateAccountClick}
                variant={"standard"}
                sx={styles.buttons}
                data-dd-action-name={RUM_ACTION_NAME.CREATE_ACCOUNT}
            >
                <span>{getMicrocopy(CommonCMS.shared, CommonCMS.button.createAccount)}</span>
            </Button>

            <Button
                rightIcon={<ECCOIcon name="arrow-right" />}
                onClick={handleLoginClick}
                variant={"standard"}
                sx={styles.buttons}
                data-dd-action-name={RUM_ACTION_NAME.LOG_IN}
            >
                <span>{getMicrocopy(CommonCMS.shared, CommonCMS.button.logIn)}</span>
            </Button>
        </Flex>
    );
}

export default AuthenticationActionBar;
